exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "button[data-v-3d15500f]:hover{background-color:#f1f1f1}.selected[data-v-3d15500f]{background-color:#fff;border:2px solid #ed1763;font-weight:700}.btn-category[data-v-3d15500f]:hover{border:2px solid #ed1763}button[data-v-3d15500f]{padding:4px 8px;border-radius:6.79px;background-color:#fff;outline:none;border:1px solid #bfbfbf;margin:10px}.div-btns-categories[data-v-3d15500f]{text-align:center}.main-content[data-v-3d15500f]{display:inline-block;width:100%;padding:15px}@media (max-width:768px){button[data-v-3d15500f]{width:125px;font-size:10px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3d15500f","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/store/components/Categories.vue
// module id = M+4f
// module chunks = 102